const Menu =  [
  { header: 'Apps' },
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    dispatch:'fetchFriends'
  },
  { divider: true },
  { header: 'Community' },
  {
    title: 'Chat',
    group: 'apps',
    icon: 'chat_bubble',
    name: 'widget-chat',
    dispatch:'fetchConvos'
  },
  {
    title: 'Projets',
    group: 'apps',
    icon: 'build',
    name: 'widget-projects',
    dispatch:'fetchProjects'
  },
  {
    title: 'Postes',
    group: 'apps',
    icon: 'format_paint',
    name: 'widget-post',
    dispatch:'fetchJobs'
  },
  {
    title: 'Events',
    group: 'apps',
    icon: 'event',
    name: 'widget-events',
    dispatch:'fetchEvents'
  },

  {
    title: 'Medias',
    group: 'apps',
    icon: 'perm_media',
    name: 'widget-medias',
    dispatch:'fetchMedias'
  },
  {
    title: 'Prayers',
    group: 'apps',
    icon: 'format_paint',
    name: 'widget-prayers',
    dispatch:'fetchPrayers'
  },
  {
    title: 'Prayers_ecc',
    group: 'apps',
    icon: 'format_paint',
    name: 'widget-prayers_ecc',
    dispatch:'fetchPrayers_ecc'
  },
];

// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu_church_admin.js